<template>
  <div class="landing">
    <a href="#" @click.prevent="doClick">
      <img src="static/img/cover.jpg" />
    </a>
  </div>
</template>

<script>
export default {
  name: "StartImage",
  methods: {
    doClick() {
      this.$eventBus.$emit("updateContentVisibility", 30);
    },
  },
};
</script>

<style scoped></style>
